import { useEffect } from "react";

export const useTheme = () => {
    useEffect(() => {
        const getPreferredTheme = () => (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");

        const setTheme = (theme: string) => {
            if (theme === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches) {
                document.documentElement.setAttribute("data-bs-theme", "dark");
            } else {
                document.documentElement.setAttribute("data-bs-theme", theme);
            }
        };

        setTheme(getPreferredTheme());

        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
            setTheme(getPreferredTheme());
        });
    }, []);
};
